import { useEffect, useRef } from "react";

// Cross-tab notice that a purchase order changed. The WO detail page opens each
// PO in a new tab (/purchase/:id), so edits made there — completing, approving,
// editing, receipts — would otherwise never reach the WO tab that opened it.
const CHANNEL_NAME = "makani-purchase-orders";

const isSupported = () => typeof BroadcastChannel !== "undefined";

let senderChannel = null;

export const notifyPurchaseOrderChanged = ({ poId, woId }) => {
  if (!woId || !isSupported()) {
    return;
  }

  if (!senderChannel) {
    senderChannel = new BroadcastChannel(CHANNEL_NAME);
  }
  senderChannel.postMessage({ poId, woId });
};

const usePurchaseOrderChanged = ({ woId, onChanged }) => {
  // Held in a ref so a callback recreated every render doesn't reopen the channel.
  const onChangedRef = useRef(onChanged);
  onChangedRef.current = onChanged;

  useEffect(() => {
    if (!woId || !isSupported()) {
      return undefined;
    }

    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = (event) => {
      if (Number(event.data?.woId) !== Number(woId)) {
        return;
      }
      onChangedRef.current?.(event.data);
    };

    return () => {
      channel.close();
    };
  }, [woId]);
};

export default usePurchaseOrderChanged;
